// import { Box } from '@mui/material';
// import { FC, memo } from 'react';
// import { useSelector } from 'react-redux';

// import { getDetailedViewTicketSummary } from 'store/ticket-service/selector';
// import { ISummaryStory } from 'store/ticket-service/types';

// import { flexMixin } from 'utils/flexMixin';

// import { UserStoryDropdown } from 'components/shared/CustomDropdown/UserStoryDropdown/UserStoryDropdown';

// import { DetailedStoryView } from './DetailedStoryView';

// interface GeneralStepSummaryProps {
// 	ticketSummaries: Array<ISummaryStory>;
// }

// const UserStoriesList: FC<GeneralStepSummaryProps> = ({ ticketSummaries }) => {
// 	const detailedViewTicketSummary = useSelector(getDetailedViewTicketSummary);

// 	return (
// 		<Box sx={{ display: 'flex', justifyContent: 'center', gap: '12px', width: '100%' }}>
// 			<Box
// 				sx={{
// 					...flexMixin({ direction: 'column', justify: 'flex-start' }),
// 					wordWrap: 'break-word',
// 					whiteSpace: 'pre-line',
// 					paddingRight: '10px',
// 					boxShadow: '0px 4px 16px 0px #2867830F',
// 					width: detailedViewTicketSummary === null ? '100%' : '50%',
// 				}}
// 			>
// 				{ticketSummaries?.map((summary, index) => (
// 					<UserStoryDropdown
// 						key={summary?.id || index}
// 						index={index + 1}
// 						userStory={summary}
// 						isLast={index === ticketSummaries.length - 1}
// 					/>
// 				))}
// 			</Box>
// 			{detailedViewTicketSummary !== null ? (
// 				<DetailedStoryView
// 					scenarios={detailedViewTicketSummary?.summaryScenarios || []}
// 					acceptanceCriteria={detailedViewTicketSummary?.summaryAcceptanceCriteria || []}
// 				></DetailedStoryView>
// 			) : null}
// 		</Box>
// 	);
// };

// export default memo(UserStoriesList);


// import { Box } from '@mui/material';
// import { FC, memo, useMemo } from 'react';
// import { useSelector } from 'react-redux';

// import { getActiveSubStage, getDetailedViewTicketSummary } from 'store/ticket-service/selector';
// import { ISummaryStory } from 'store/ticket-service/types';
// import { GeneralStepConversationTopics } from 'core/enums/common';
// import { flexMixin } from 'utils/flexMixin';

// import { UserStoryDropdown } from 'components/shared/CustomDropdown/UserStoryDropdown/UserStoryDropdown';
// import { DetailedStoryView } from './DetailedStoryView';

// interface UserStoriesListProps {
//   ticketSummaries: Array<ISummaryStory>;
// }

// const UserStoriesList: FC<UserStoriesListProps> = ({ ticketSummaries }) => {
//   const detailedViewTicketSummary = useSelector(getDetailedViewTicketSummary);
//   const activeSubStage = useSelector(getActiveSubStage);
  
//   // Filter ticketSummaries based on the active sub-stage
//   const filteredSummaries = useMemo(() => {
//     if (ticketSummaries?.length) {
//       // If a specific category is selected (activeSubStage is defined)
//       if (activeSubStage !== undefined) {
//         const currentCategory = activeSubStage as GeneralStepConversationTopics;
        
//         return ticketSummaries.filter(summary => 
//           // Show stories that match the selected category
//           summary.subStage === currentCategory ||
//           // Or stories without a defined category if we're showing Functional Requirements (likely default)
// 		  // in other words, it check if the current category is "Functional requirements" and the summary does not have a subStage
//           (currentCategory === GeneralStepConversationTopics["Functional requirements"] && !summary.subStage)
//         );
//       }
//     }
    
//     // If no filtering needed or no valid activeSubStage, return all summaries
//     return ticketSummaries || [];
//   }, [ticketSummaries, activeSubStage]);

//   return (
//     <Box sx={{ display: 'flex', justifyContent: 'center', gap: '12px', width: '100%' }}>
//       <Box
//         sx={{
//           ...flexMixin({ direction: 'column', justify: 'flex-start' }),
//           wordWrap: 'break-word',
//           whiteSpace: 'pre-line',
//           paddingRight: '10px',
//           boxShadow: '0px 4px 16px 0px #2867830F',
//           width: detailedViewTicketSummary === null ? '100%' : '50%',
//         }}
//       >
//         {filteredSummaries.length > 0 ? (
//           filteredSummaries.map((summary, index) => (
//             <UserStoryDropdown
//               key={summary?.id || index}
//               index={index + 1}
//               userStory={summary}
//               isLast={index === filteredSummaries.length - 1}
//             />
//           ))
//         ) : (
//           <Box sx={{ padding: '20px', textAlign: 'center', color: 'gray' }}>
//             No user stories available for this category, please generate some by providing the required information.
//           </Box>
//         )}
//       </Box>
//       {detailedViewTicketSummary !== null ? (
//         <DetailedStoryView
//           scenarios={detailedViewTicketSummary?.summaryScenarios || []}
//           acceptanceCriteria={detailedViewTicketSummary?.summaryAcceptanceCriteria || []}
//         />
//       ) : null}
//     </Box>
//   );
// };

// export default memo(UserStoriesList);








import { Box } from '@mui/material';
import { FC, memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getActiveStep, getActiveSubStage, getDetailedViewTicketSummary } from 'store/ticket-service/selector';
import { ISummaryStory } from 'store/ticket-service/types';
import { GeneralStepConversationTopics, TicketStages } from 'core/enums/common';
import { flexMixin } from 'utils/flexMixin';

import { UserStoryDropdown } from 'components/shared/CustomDropdown/UserStoryDropdown/UserStoryDropdown';
import { DetailedStoryView } from './DetailedStoryView';

interface UserStoriesListProps {
  ticketSummaries: Array<ISummaryStory>;
}

const UserStoriesList: FC<UserStoriesListProps> = ({ ticketSummaries }) => {
  const detailedViewTicketSummary = useSelector(getDetailedViewTicketSummary);
  const activeSubStage = useSelector(getActiveSubStage);
  const activeStep = useSelector(getActiveStep)
  
  // Filter ticketSummaries based on the active sub-stage
  const filteredSummaries = useMemo(() => {
    if (!ticketSummaries?.length) {
      return [];
    }
    
    // Check if we're in the General step
    const isGeneralStep = activeStep === TicketStages.general;
    
    // Only apply category filtering if we're in the General step
    if (isGeneralStep && activeSubStage !== undefined) {
      const currentCategory = activeSubStage as GeneralStepConversationTopics;
      
      return ticketSummaries.filter(summary => 
        summary.subStage === currentCategory ||
        (currentCategory === GeneralStepConversationTopics["Functional requirements"] && !summary.subStage)
      );
    }
    
    // For other steps (like Use Cases), show all user stories
    return ticketSummaries;
  }, [ticketSummaries, activeSubStage, activeStep]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', gap: '12px', width: '100%' }}>
      <Box
        sx={{
          ...flexMixin({ direction: 'column', justify: 'flex-start' }),
          wordWrap: 'break-word',
          whiteSpace: 'pre-line',
          paddingRight: '10px',
          boxShadow: '0px 4px 16px 0px #2867830F',
          width: detailedViewTicketSummary === null ? '100%' : '50%',
        }}
      >
        {filteredSummaries.length > 0 ? (
          filteredSummaries.map((summary, index) => (
            <UserStoryDropdown
              key={`${summary?.id || index}-${summary?.summaryAcceptanceCriteria?.length || 0}-${summary?.summaryScenarios?.length || 0}`}
              index={index + 1}
              userStory={summary}
              isLast={index === filteredSummaries.length - 1}
            />
          ))
        ) : (
          <Box sx={{ padding: '20px', textAlign: 'center', color: 'gray' }}>
            No user stories available for this category, please generate some by providing the required information.
          </Box>
        )}
      </Box>
      {detailedViewTicketSummary !== null ? (
        <DetailedStoryView
          scenarios={
            Array.isArray(detailedViewTicketSummary?.summaryScenarios)
              ? detailedViewTicketSummary.summaryScenarios
              : []
          }
          acceptanceCriteria={
            Array.isArray(detailedViewTicketSummary?.summaryAcceptanceCriteria)
              ? detailedViewTicketSummary.summaryAcceptanceCriteria
              : []
          }
        />
      ) : null}
    </Box>
  );
};

export default UserStoriesList;